import { call, delay, put, select } from 'redux-saga/effects';
import { ApiError } from 'store/api/types';
import { FetchViesContactsRequestAction } from '../types';
import { checkResponse } from 'store/utils';

import { GetViesContactsResponse, getViesContacts } from '../api';
import { turnMessageOn } from 'store/app/actions';
import { MessageData } from 'store/app/types';
import {
  fetchViesContactsFailure,
  fetchViesContactsSuccess,
  fetchViesInfoRequest,
} from '../actions';
import { getViesInfos } from '../selectors';
import { getOrgOrganisations } from 'store/organisation/selectors';
import { fetchOrganisationsRequest } from 'store/organisation/actions';
import { logoutRequest } from 'store/auth/actions';
import { renderErrorMessage } from 'utils/render-error-message';

/* eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types */
export function* fetchViesContactsSaga(action: FetchViesContactsRequestAction) {
  try {
    let err: ApiError | null;
    const { connectionId, suppressMessages } = action.payload;

    const response: GetViesContactsResponse = yield call(
      getViesContacts,
      connectionId
    );
    err = checkResponse(response?.responseMessage);
    if (err) throw err;

    const viesInfos = yield select(getViesInfos);

    let providerName = '';
    // When suppressMessages is true (entity/transactions side), we only need
    // contacts; skip the extra fetchViesInfoRequest + orgs loading to avoid
    // additional network calls. VIES pages call this without suppressMessages
    // and keep the existing behaviour.
    if (!suppressMessages) {
      if (viesInfos.length === 0) {
        yield put(fetchViesInfoRequest(connectionId));
        let orgs = yield select(getOrgOrganisations);
        if (!orgs) {
          yield put(fetchOrganisationsRequest());
          for (let attempt = 0; attempt < 10; attempt++) {
            yield delay(200);
            orgs = yield select(getOrgOrganisations);
            if (orgs?.length) break;
          }
        }
        if (orgs) {
          const org = orgs.find((o) => o.connectionId === connectionId);
          providerName = org?.providerName ?? '';
        }
      } else {
        const selViesInfo = viesInfos.find(
          (vi) => vi.connectionId === connectionId
        );
        providerName = selViesInfo ? selViesInfo.providerName : '';
      }
    }
    const contacts = response.data.contacts;

    contacts.map(function (c) {
      c.key = c.contactUuid;
      c.providerName = providerName;
    });
    yield put(fetchViesContactsSuccess(contacts));
  } catch (error: any) {
    const message: MessageData | null = renderErrorMessage(error);
    if (message && !action.payload?.suppressMessages) {
      yield put(turnMessageOn(message));
    } else if (!message) {
      yield put(logoutRequest());
    }
    yield put(fetchViesContactsFailure());
  }
}
